<mat-spinner [color]="color" [diameter]="diameter" [mode]="mode" [strokeWidth]="strokeWidth" 
			 [value]="value" [class]="spinerClass" [style]="spinerStyle"></mat-spinner>
<ng-content></ng-content>
